<template>
	<div class="title-container">
		<div :style="titleStyles" class="title-container__title"><slot></slot></div>
		<span class="title-container__subtitle" v-if="hasSubtitle" v-html="subtitle"></span>
	</div>
</template>

<style lang="scss" scoped>
.title-container {
	text-align: center;
	margin-top: 1.5rem;
	font-family: var(--font-family-title);

	&__title {
		font-weight: bold;
		font-size: 2rem;
		line-height: 1.2;
	}
}
</style>

<script>
import { computed } from '@vue/reactivity'
export default {
	name: 'Title',
	props: {
		titleStyles: {
			type: Object,
			default: () => ({})
		},
		subtitle: {
			type: String,
			default: ''
		}
	},
	setup(props) {
		return {
			hasSubtitle: computed(() => Boolean(props.subtitle))
		}
	}
}
</script>
